<template>
  <portlet
          :icon="'fad fa-building'"
          :title="'Bedrijf toevoegen'"
          :actionsBlock="true"
          :footer="true"
  >
    <template slot="actionsBlock">
      <router-link tag="button" :to="{name:'customers'}" class="btn btn-secondary">
        <i class="fas fa-long-arrow-left mr-2"></i>
        Terug
      </router-link>
    </template>

    <template slot="portletBody">
      <form action>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="customer-name">Naam</label>
            <input
                    v-validate="'required'"
                    name="name"
                    id="customer-name"
                    type="text"
                    class="form-control"
                    v-model="customer.name"
            />
            <span v-if="errors.first('name')" class="small text-danger">Dit veld is verplicht</span>
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-alias">Alias</label>
            <input
                    v-validate="'required'"
                    name="alias"
                    id="customer-alias"
                    type="text"
                    class="form-control"
                    v-model="customer.alias"
            />
            <span v-if="errors.first('alias')" class="small text-danger">Dit veld is verplicht</span>
          </div>
          <div class="form-group col-8 col-lg-3">
            <label for="customer-zipcode">Postcode</label>
            <input
                    v-validate="'required'"
                    name="zipcode"
                    id="customer-zipcode"
                    type="text"
                    @keyup="uppercaseZipCode()"
                    class="form-control"
                    v-model="customer.zipcode"
            />
            <span v-if="errors.first('zipcode')" class="small text-danger">Dit veld is verplicht</span>
          </div>
          <div class="form-group col-4 col-lg-1 rm-p-l">
            <label for="customer-nr">Nr</label>
            <input
                    v-validate="'required'"
                    name="nr"
                    id="customer-nr"
                    type="text"
                    class="form-control"
                    v-model="customer.nr"
            />
            <span v-if="errors.first('nr')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="customer-street">Straatnaam</label>
            <input
                    v-validate="'required'"
                    name="street"
                    id="customer-street"
                    type="text"
                    class="form-control"
                    v-model="customer.street"
            />
            <span v-if="errors.first('street')" class="small text-danger">Dit veld is verplicht</span>
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-location">Woonplaats</label>
            <input
                    v-validate="'required'"
                    name="location"
                    id="customer-location"
                    type="text"
                    class="form-control"
                    v-model="customer.location"
                    @change="addLocationToDepartments"
            />
            <span v-if="errors.first('location')" class="small text-danger">Dit veld is verplicht</span>
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-location">Vestigingen</label>
            <tags-input element-id="tags"
                        placeholder="Voeg vestiging toe en druk op enter"
                        display-field="Alle vestigingen"
                        typeahead-style="dropdown"
                        v-model="customer.departments"></tags-input>
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-telephone">Telefoonnummer</label>
            <input
                    v-validate="'required'"
                    name="telephone"
                    id="customer-telephone"
                    type="text"
                    class="form-control"
                    v-model="customer.telephone"
            />
            <span v-if="errors.first('telephone')" class="small text-danger">Dit veld is verplicht</span>
          </div>

          <div class="form-group col-lg-4">
            <label for="customer-website">Website</label>
            <input
                    name="customer-website"
                    id="customer-website"
                    type="text"
                    class="form-control"
                    v-model="customer.website"
            />
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-telephone">E-mailadres</label>
            <input
                    v-validate.continues="'required|email'"
                    name="email"
                    id="customer-email"
                    type="text"
                    class="form-control"
                    v-model="customer.email"
            />
            <ul>
              <li class="small text-danger" v-for="error in errors.collect('email')" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-contact">Contactpersoon</label>
            <input
                    name="customer-contact"
                    id="customer-contact"
                    type="text"
                    class="form-control"
                    v-model="customer.contact"
            />
          </div>
          <div class="form-group col-lg-4">
            <label for="customer-cost-center">Kostenplaats</label>
            <select
                    name="customer-cost-center"
                    id="customer-cost-center"
                    class="form-control"
                    v-model="customer.costCenter"
            >
              <option value="">Geen</option>
              <option v-for="costCenter in getCostCenters" :value="costCenter.name" :key="costCenter.id">
                {{costCenter.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="purchasing-factor">Inkoop factor</label>
            <input
                    name="purchasing-factor"
                    id="purchasing-factor"
                    type="number"
                    step=".1"
                    class="form-control"
                    v-model="customer.purchasingFactor"
            />
          </div>
          <div class="form-group col-lg-4">
            <label for="sale-factor">Verkoop factor</label>
            <input
                    name="sale-factor"
                    id="sale-factor"
                    type="number"
                    step=".1"
                    class="form-control"
                    v-model="customer.saleFactor"
            />
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label for="customer-description">Omschrijving (interne notities)</label>
            <textarea
                    rows="8"
                    id="customer-description"
                    name="customer-description"
                    class="form-control"
                    v-model="customer.description"
            ></textarea>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label for="customer-defaultInstructions">Welkomst email standaard</label>
            <tiptap-editor
                    v-model="customer.defaultInstructions"
                    :content="customer.defaultInstructions"/>
          </div>
        </div>
      </form>
    </template>
    <div slot="portletFooter" class="col text-right">
      <button @click="addCustomer" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {swalModals} from './../../components/mixins/swalModals.js';
  import {getPostalData} from './../../components/mixins/getPostalData';

  import axios from 'axios';


  export default {
    mixins: [swalModals,getPostalData],
    data() {
      return {
        note: 'Test',
        disableNavigation: false,
        customerCopy: null,
        customer: {
          activeCustomer: false,
          name: '',
          alias: '',
          zipcode: '',
          nr: '',
          street: '',
          location: '',
          telephone: '',
          email: '',
          website: '',
          contact: '',
          costCenter: '',
          purchasingFactor: null,
          saleFactor: null,
          description: '',
          departments: [],
          geoLocation: {lat: null, lng: null},
          defaultInstructions: '<p>Via deze weg wensen wij jou succes op je eerste werkdag!</p>' +
              '<p>Nog even wat praktische punten:</p>' +
              '<ul><li>Indien je voor wekelijkse betaling hebt gekozen krijg je de gewerkte uren van deze week krijg je volgende week vrijdag uitbetaald.</li>' +
              '<li>Wanneer je voor 4 wekelijkse betaling hebt gekozen krijg je weeknummer 1,5,9,13 enz. betaald.</li>' +
              '<li>Mocht je vragen hebben van welke aard dan ook? bel ons, wij staan altijd voor je klaar!</li></ul>'
        }
      };
    },
    methods: {
      addLocationToDepartments() {
        if(!this.customer.departments || !this.customer.departments.length) {
          this.customer.departments = [ {key: '' , value: this.customer.location } ];
        }
      },
      uppercaseZipCode() {
        this.customer.zipcode = this.customer.zipcode.toUpperCase();
      },
      autoFillBasedOnPostal(customer) {
        let rege = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
        customer = this.customer;

        if(customer.zipcode && customer.nr) {
          if(rege.test(customer.zipcode)) {
            this.$store.commit('setLoading', true);
            this.getPostalData(customer.zipcode,customer.nr).then(res => {
              if(res.status == 200) {
                let data = res.data;
                this.customer.location = data.city;
                this.customer.street = data.street;
                this.addLocationToDepartments()
              }
            }).catch(e => {
              this.$store.commit('setLoading', false);

              console.error(e);
            }).finally(() => {
              this.$store.commit('setLoading', false);

            });
          }
        }
      },
      addCustomer() {
        this.$validator.validate().then(result => {
          if(result) {
            this.disableNavigation = false;
            this.customer.createdBy = this.$store.getters.getUserData;
            this.customer.department = this.$store.getters.getUserData.selectedDepartment;
            if(!this.customer.departments || !this.customer.departments.length) {
              this.customer.departments = [ {key: '' , value: this.customer.location } ];
            }
            console.log(this.customer)
            this.$store.dispatch('customers/set', this.customer).then(() => {
              this.$router.push('/customers');

              this.$toasted.global.successRequest({
                message: 'Bedrijf aangemaakt'
              });

              this.customer = {};
            }).catch(error => {
              this.$toasted.global.failedRequest();
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      }
    },
    beforeRouteLeave(to, from, next) {
      if(this.disableNavigation) {
        this.swalUnsavedChanges().then(result => {
          if(result.value) {
            next();
            this.customer = this.customerCopy;
          }
        });
      } else {
        next();
      }
    },
    computed: {
      ...mapGetters('costCenters', ['getCostCenters']),
    },
    watch: {
      customer: {
        handler: function (val, oldV) {
          if(JSON.stringify(val) !== JSON.stringify(this.customerCopy)) {
            this.disableNavigation = true;
          }


        },
        deep: true
      },
      'customer.nr': function (newV, oldV) {
        this.autoFillBasedOnPostal(newV);
      },
      'customer.zipcode': function (newV, oldV) {
        this.autoFillBasedOnPostal(newV);
      }
    }
  };
</script>
